import api from './api';
import {
  ITelegramLinkResponse,
  ITelegramSubscription,
} from 'interfaces/telegram.interface';

const _resourceUrl = '/front/telegram';

export const getTelegramStatus = (): Promise<ITelegramLinkResponse> => {
  return api.get(`${_resourceUrl}/status`);
};

export const getTelegramSubscriptions = (): Promise<ITelegramSubscription[]> => {
  return api.get(`${_resourceUrl}/subscriptions`);
};

/** Mints a single-use deep link; the chat that opens it gets bound to this applicant. */
export const createTelegramLink = (): Promise<ITelegramLinkResponse> => {
  return api.post(`${_resourceUrl}/link-token`);
};

export const disconnectTelegram = (id: number): Promise<boolean> => {
  return api.delete(`${_resourceUrl}/subscriptions/${id}`);
};
